import { ArnAuthService } from './auth';
import { ArnI18nService } from './i18n';
import { ArnConditionService } from './condition';
import { ArnTrackingService } from './track';
import { ArnDataService } from './data';
import { ArnNftService } from './nft/ArnNftService';
import { ArnLogger } from './log';

/**
 * Arianee web3 client.
 */
export class ArnClient<M = any> {
  constructor(
    /**
     * The ARN client authentication service.
     */
    readonly auth: ArnAuthService,
    /**
     * The ARN client conditions checking service.
     */
    readonly condition: ArnConditionService,
    /**
     * The ARN client data access service.
     */
    readonly data: ArnDataService,
    /**
     * The ARN client internationalization service.
     */
    readonly i18n: ArnI18nService<M>,
    /**
     * The ARN client NFT info service.
     */
    readonly nft: ArnNftService,
    /**
     * The ARN client tracking service.
     */
    readonly track: ArnTrackingService,
    /**
     * The ARN client logging service.
     */
    readonly log: ArnLogger
  ) {}
}
